var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveMobileUsersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5667 28.1332L35.2 25.7832L31.6667 29.3165L28.1333 25.7832L25.7833 28.1332L29.3167 31.6665L25.7833 35.1998L28.1333 37.5665L31.6667 34.0165L35.2 37.5665L37.5667 35.1998L34.0167 31.6665L37.5667 28.1332ZM24.2333 38.3332H11.6667C9.83334 38.3332 8.33334 36.8498 8.33334 34.9998V4.99984C8.33334 3.14984 9.81668 1.6665 11.6667 1.6665H28.3333C30.1667 1.6665 31.6667 3.14984 31.6667 4.99984V21.6665C30.5 21.6665 29.3833 21.8832 28.3333 22.2498V8.33317H11.6667V31.6665H21.6667C21.6667 34.2332 22.6333 36.5665 24.2333 38.3332Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveMobileUsersIcon);
export default __webpack_public_path__ + "static/media/InactiveMobileUsersIcon.8bed1151.svg";
export { ForwardRef as ReactComponent };